export default "/images/approvals.svg?cf0e93a74a0d065bb3502824dd2e1483";